export default "<app-invoice-detail-list-view></app-invoice-detail-list-view>\r\n";